import EventLabelAbstractModal, { EventLabelAbstractModalProps } from "../EventLabelAbstractModal";

export type CreateEventTypeModalProps = EventLabelAbstractModalProps;

export const CreateEventTypeModal = (props: CreateEventTypeModalProps) => {
  return <EventLabelAbstractModal {...props} />;
};

export default CreateEventTypeModal;